import React, {useState, useCallback, useEffect} from "react";
import {GoogleMap, Marker, useLoadScript} from "@react-google-maps/api";
import mapStyles from "./mapStyle.json";
import Spinner from "../UI/Spinner";
import Panel from "./Panel"
import Aux from '../../hoc/Auxiliary';
import TableContainer from "../Accounts/Account/Transactions/Table/TableContainer";

let harnoisIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMSAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTUzMTkgMC4wMTE0MjI2TDAuMDY1OTYzOCAzMi42ODg3TDAgMzNMMTMuNjU3NSAyMi4yODI3TDEzLjY5MDUgMjIuMjU3TDE4LjM1MjkgMEw2Ljk1MzE5IDAuMDExNDIyNlpNMTQuODU5OSAyMi4yNDg0TDIzLjgzNjkgMzIuOTk0M0wzMSAwSDE5LjUwNzNMMTQuODU5OSAyMi4yNDg0WiIgZmlsbD0iI0UxMjUxQiIvPgo8L3N2Zz4K";
let EssoIcon = "data:image/svg+xml;base64,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";

/*
* Documentation
* https://react-google-maps-api-docs.netlify.app/
* https://medium.com/@allynak/how-to-use-google-map-api-in-react-app-edb59f64ac9d
* https://codesandbox.io/s/gmaps-issue-ivlrq?file=/src/index.js
* https://codesandbox.io/s/markers-center-on-click-rf2i8?file=/src/index.js
*
* https://github.com/JustFly1984/react-google-maps-api
*
* */

const Markers = props => (
    <Marker
        key={`${props.item.position.lat}${props.item.position.lng}`}
        icon={getMarkerIcon(props.item.banner)}
        label={
            {
                text: props.item.transactions.length.toString(),
                color: (props.item.transactions.length > 21) ? 'red' : 'black',
                className: "map-label",
            }
        }
        onClick={() => props.onClick(props.item)}
        position={{
            lat: props.item.position.lat,
            lng: props.item.position.lng
        }}
    />
);

function getMarkerIcon(banner) {
    let icon = "";
    switch (banner) {
        case "Harnois":
            icon = harnoisIcon;
            break;
        case "Esso":
            icon = EssoIcon;
            break;
        default:
            icon = harnoisIcon;
    }
    return icon
}


function GMaps(props) {

    const {isLoaded} = useLoadScript({
        googleMapsApiKey: "AIzaSyDn9tIA-moPPpUkeb1WzoJMYxsizfeSIRk"
    });

    let markers = [];
    Object.keys(props.supplyPoints).forEach(function(key,index) {
        if (props.supplyPoints[key].position.lat !== null && props.supplyPoints[key].position.lng !== null)
        markers[key] = props.supplyPoints[key];
    });

    const [mapInstance, setMapInstance] = useState(null);
    const [activeItem, setActiveItem] = useState(null);

    useEffect(() => {

        if (mapInstance && activeItem) {
            const latlng = {
                lat: activeItem.position.lat - 0.15, /*HACK TO SEE IN VIEWPORT*/
                lng: activeItem.position.lng
            };
            mapInstance.panTo(latlng);
            document.querySelector(".map-panel").classList.add('open');
        }
    }, [activeItem, mapInstance]);


    const onLoad = useCallback(map => {
        setMapInstance(map);
        const bounds = new google.maps.LatLngBounds();
        Object.keys(markers).map(function (keyName, keyIndex) {
            return (
                bounds.extend(markers[keyName]["position"])
            )
        });
        map.fitBounds(bounds);
    });

    const fiBoundReset = () => {
        const bounds = new google.maps.LatLngBounds();
        Object.keys(markers).map(function (keyName, keyIndex) {
            return (
                bounds.extend(markers[keyName]["position"])
            )
        });
        mapInstance.fitBounds(bounds);
    }

    const localize = () => {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                mapInstance.setCenter({lat: position.coords.latitude, lng: position.coords.longitude})
                mapInstance.setZoom(10);
            },
            function (error) {
                fiBoundReset();
            }
        );
    };

    const zoomIN = () => {
        mapInstance.setZoom(mapInstance.zoom + 1);
    };

    const zoomOut = () => {
        mapInstance.setZoom(mapInstance.zoom - 1);
    };

    const togglePopup = () => {
        document.querySelector(".map-panel").classList.remove('open');
        setActiveItem(null);
        fiBoundReset();
    }

    const renderMap = () => {

        return (
            <div>
                <div className="map-container">
                    <GoogleMap
                        mapContainerStyle={{width: '100%', height: '900px'}}
                        options={{
                            styles: mapStyles,
                            zoomControl: false,
                            streetViewControl: false,
                            mapTypeControl: false,
                            minZoom: 4,
                            maxZoom: 18,
                        }}
                        zoom={6}
                        onLoad={onLoad}
                    >

                        {Object.keys(markers).map(function (keyName, keyIndex) {
                            return (
                                <Markers
                                    key={`${markers[keyName]["position"]["lat"]}${markers[keyName]["position"]["lng"]}`}
                                    onClick={setActiveItem}
                                    item={markers[keyName]}
                                />
                            )
                        })
                        }
                    </GoogleMap>

                    <button className="btn btn--map" onClick={() => localize()}>
                        <i className="far fa-crosshairs"></i>
                    </button>
                    <button className="btn btn--map btn--map--plus" onClick={() => zoomIN()}>
                        <i className="far fa-plus"></i>
                    </button>
                    <button className="btn btn--map btn--map--minus " onClick={() => zoomOut()}>
                        <i className="far fa-minus"></i>
                    </button>
                    { /*tableContainerProps*/

                        activeItem ? (      <Panel
                            data={activeItem}
                            period={props.dataFilterType}
                            closePopup={togglePopup} >
                                {props.children}
                                <TableContainer
                                    columns={props.tableContainerProps.columns}
                                    data={activeItem.transactions}
                                    doXLSExport={props.tableContainerProps.doXLSExport}
                                    doXLSDetailExport={props.tableContainerProps.doXLSDetailExport}
                                    checked={props.tableContainerProps.checked}
                                    onSort={props.tableContainerProps.handleSort}
                                    setSortByCallback={props.tableContainerProps.setSortByCallback}
                                    initialStateField={props.tableContainerProps.sortField}
                                    initialStateDirection={props.tableContainerProps.sortDirection}
                                />
                            </Panel>
                        ) : ''
                    }

                </div>
            </div>

        );
    };

    return (
        <Aux>
            {isLoaded ? renderMap() : <Spinner/>}
        </Aux>
    );
}

export default GMaps;
